import { useCallback } from "react";

import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";

import { Route as SessionsRoute } from "@app/navigation/routes/_private/sessions";
import { Route as TwoFaVerifyRoute } from "@app/navigation/routes/_private/two-fa-verify";
import { SecurityPageConnector } from "@pages/security/security-page-connector";

export const Route = createFileRoute("/_private/security")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const navigate = useNavigate();

  const handleGoTwoFA = useCallback(async () => {
    await navigate({
      to: TwoFaVerifyRoute.fullPath,
    });
  }, [navigate]);
  const handleGoSessions = useCallback(async () => {
    await navigate({
      to: SessionsRoute.fullPath,
    });
  }, [navigate]);

  return (
    <SecurityPageConnector
      onGoBack={router.history.back}
      onGoSessions={handleGoSessions}
      onGoTwoFA={handleGoTwoFA}
    />
  );
}
